import { render } from "./Reading.vue?vue&type=template&id=0dec4dc7&scoped=true"
import script from "./Reading.vue?vue&type=script&lang=js"
export * from "./Reading.vue?vue&type=script&lang=js"

import "./Reading.vue?vue&type=style&index=0&id=0dec4dc7&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dec4dc7"]])

export default __exports__